module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12 tac\">\n    <h1 class=\"mt48\">Please select a shift!</h1>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/route-info/route-info.component.html
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/route-info/route-info.component.html
// module chunks = main